import "chartjs-plugin-colorschemes";
import { Action, ActionDefinition } from "components/actions/actions";
import { ValueComponent, ValueComponentDefinition } from "components/components/Component";
import { ValueBaseComponent } from "components/components/ValueBaseComponent";
import { I18nMessage, I18nMessageDefinition } from "components/i18n/I18nMessage";
import { initNumericContentWebComponent, NumericContent, NumericContentData } from "./numericContent";
import { initTiletWebComponent } from "./tileElement";

initTiletWebComponent();
initNumericContentWebComponent();
export class Tile extends ValueBaseComponent<TileDefinition> implements ValueComponent {

    readonly componentType: string = "tile";
    private contentElement: NumericContent;

    constructor(definition: TileDefinition) {
        super(definition);
    }

    public render(): Element {
        let title = new I18nMessage(this.definition.title).toString();
        let subtitle = new I18nMessage(this.definition.subtitle).toString();
        let hasActionClass = (this.definition.action == null) ? "has-no-action ": "has-action";

        this.view = createElementFromHTML(`<s6-tile 
        title="${title}" 
        subtitle="${subtitle}" 
        width="${this.definition.width}" 
        lgwidth="${this.definition.lgwidth}" 
        mdwidth="${this.definition.mdwidth}" 
        style="${this.definition.style}"
        class="${hasActionClass}">Hello Tile</s6-tile>`);
        this.contentElement =
            createElementFromHTML(
                `<s6-tile-numeric-content 
                size="${(this.definition.content as NumericContentDefinition)?.size}" 
                iconFont="${(this.definition.content as NumericContentDefinition)?.iconFont}" 
                decimals="${(this.definition.content as NumericContentDefinition)?.decimals}" >
                </s6-tile-numeric-content>`) as NumericContent;
        this.view.querySelector(".c-tile__inner").appendChild(this.contentElement);

        if (this.definition.action != null) {
            this.view.addEventListener("click", () => {
                new Action(this.definition.action, null).run({});
            });
        }
        return this.view;
    }

    public value(data: NumericContentData) {
        this.contentElement.data = data;
    }

    public getValue() {
        throw new Error("Method not implemented.");
    }
}

export interface TileDefinition extends ValueComponentDefinition {
    title?: I18nMessageDefinition;
    subtitle?: I18nMessageDefinition;
    footer?: I18nMessageDefinition;
    style: "clean" | "boxed";
    content: TileContent;
    width?: number;
    lgwidth?: number;
    mdwidth?: number;
    smwidth?: number;
    action?: ActionDefinition;
}

export interface TileContent { }

export interface NumericContentDefinition extends TileContent {
    iconFont?: string;
    size?: "small" | "medium" | "large";
    decimals?: number;
    level?: "error" | "warning" | "info" | "success";
}


function createElementFromHTML(htmlString): HTMLElement {
    let div = document.createElement("div");
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild as HTMLElement;
}